import Vue from 'vue'
import Slider from 'components/ui/slider'
import Loading from 'components/ui/loading'
import Multiselect from 'components/ui/multiselect'
import SingleSelect from 'components/ui/singleselect'

import productPanel from 'components/ui/productPanel'

Vue.component('ui-multiselect', Multiselect)
Vue.component('ui-singleselect', SingleSelect)
Vue.component('ui-slider', Slider)
Vue.component('ui-loading', Loading)
Vue.component('product-panel', productPanel)



// WEBPACK FOOTER //
// ./client/plugins/ui-components.js